export default Object.freeze({
    ERRORS: {
        UNKOWN_AVAILABILITY_OFFER: 'AVAILABILITY.UNKOWN_AVAILABILITY_OFFER',
    },
})
